export class PermissionSetUsersIDRequestModel
{
    UsersIDs:number[]=[]
    PermissionSetId:number;

}